module.exports = __webpack_public_path__ + "static/media/remember_3.ba51349c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/remember_3.svg
// module id = 607
// module chunks = 0